module.exports = __webpack_public_path__ + "static/media/kitchen.b466095c.png";